// general
export const TIMEOUT_MINS = 60 * 10  // 10 hours

// content types
export const CONTENTTYPE_IDENTITY = 83  // 82 on stg, 83 on prod
export const CONTENTTYPE_EMPLOYER = 72  // , 72 on prod
export const CONTENTTYPE_CLIENT = 52  // 51 on stg, 52 on prod
export const CONTENTTYPE_CASE = 49  // , 49 on prod
export const CONTENTTYPE_FILE = 79  // , 79 on prod
export const CONTENTTYPE_EMAIL = 54  // , 54 on prod
export const CONTENTTYPE_MESSAGE = 56  // 55 on stg, 56 on prod
export const CONTENTTYPE_REQUESTRUN = 130  // , 130 on prod
export const CONTENTTYPE_PAYROLLRUN = 77  // , 77 on prod
export const CONTENTTYPE_WHATSAPPMESSAGE = 122  // 121 on stg, 122 on prod

// file type node ids
export const FILETYPE_PAYSLIP = "RmlsZVR5cGVOb2RlOjEwYTQ0MGE1LWM0ZjctNGQ1Yi1hYTBkLWNiNjc3ZWQwNTg0Ng=="
export const FILETYPE_RETAIL_INVOICE = "RmlsZVR5cGVOb2RlOmRjZWY3NjBiLTc1ZjItNGRiMS05OGE1LTY0ZmYyMTEwMTZhZg=="
export const FILETYPE_LOANAPPLICATION = "RmlsZVR5cGVOb2RlOjIwZTQ5M2QxLTdkZmEtNDllYy1iMzA4LWU2ZTBmYzNkZmU2OA=="
export const FILETYPE_LOANAPPLICATION_CONSOLIDATION_STATEMENT = "RmlsZVR5cGVOb2RlOjdlNGRkY2MxLTlkYTktNGI0NC1iZmZiLTU4YjBjNzA4ZjlmZQ=="
export const FILETYPE_LOAN_PROOF_OF_PAYMENT = "RmlsZVR5cGVOb2RlOmY2MTRiMjAyLWRmZWUtNDRmMC1iYmYxLTEwMjk5ODZmMGE0OQ=="
export const FILETYPE_MANUAL_UPLOAD = "RmlsZVR5cGVOb2RlOmI2OWE3NmJmLTNkOTQtNGMyNC05NWRhLWM0ODBmMWE0MTRiYw=="
export const FILETYPE_EMPLOYEE_PAYSLIP = "RmlsZVR5cGVOb2RlOjY1OThhNzA5LTYwZWYtNGJjNC1hNTVhLWEyZTUzY2RhNTY5OA=="
export const FILETYPE_WHATSAPP_MEDIA = "RmlsZVR5cGVOb2RlOjM2ZDQ2N2ZlLTNhYWUtNGViYi1iMzNhLThmMDE1ZjdmNDlmZg=="
export const FILETYPE_CELLPHONE_NUMBER_CHANGE = "RmlsZVR5cGVOb2RlOjM1NzBmNzA0LWJkOTUtNDE3ZC04OTk3LWUzZTY4OWQ0YzBkNQ=="
export const FILETYPE_IDENTITY_VERIFICATION = "RmlsZVR5cGVOb2RlOmNmNzczNWM2LTFmZTUtNGVjOS1iZTY3LTFlNWViYjZmNTVjYQ=="
export const FILETYPE_EMPLOYEE_CSV_IMPORT = "RmlsZVR5cGVOb2RlOjZiYjI1ZTEyLTVhMzMtNDdhNy04ZDczLTFhYzFiMzUzZmJkMg=="
// application forms
export const FILETYPE_FORM_APPLICATION_ASSOCIATION_MEMBER = "RmlsZVR5cGVOb2RlOjI2NDIzYWM4LTExODYtNGEzMy1hNDgxLWU5ZmFkNGQxZTgxOA=="
export const FILETYPE_FORM_APPLICATION_REWARDS = "RmlsZVR5cGVOb2RlOjMwYjNiZTA2LWJkMmYtNDNlNy1iMmQ5LTI3NDQ4MDkwYTJmNg=="
export const FILETYPE_FORM_APPLICATION_INVESTMENTS = "RmlsZVR5cGVOb2RlOmYzYTBkMTE3LWQ3MzUtNDBlMC1hNzE2LTIxMzU0OTgzMWM4Zg=="
export const FILETYPE_FORM_APPLICATION_FUNERAL_COVER_VOLUNTARY = "RmlsZVR5cGVOb2RlOjZiNmQ0N2EzLTgzZDEtNDVkYi05OGY2LTZjZTMxYTc3NjJhNw=="
export const FILETYPE_FORM_APPLICATION_FUNERAL_COVER_EXTENDED_FAMILY = "RmlsZVR5cGVOb2RlOmE4ZTZhMTcwLTVkOWEtNDlhMi04Yjk1LWRmNGRkNWI0NWIwMg=="
// forms
export const FILETYPE_FORMS = "RmlsZVR5cGVOb2RlOjJhZWE4OWE0LWY3MGYtNGExMS1hZGNjLTdkNzI1MGZjMjc3Yw=="
// short codes
export const FILETYPE_LOANAPPLICATION_SHORTCODE = 'CLA'
export const FILETYPE_PAYSLIP_SHORTCODE = 'CPS'
export const FILETYPE_RETAIL_INVOICE_SHORTCODE = 'CRI'
export const FILETYPE_CONSOLIDATION_STATEMENT_SHORTCODE = 'CSS'

// Picsa identities
export const IDENTITY_PICSAOS = "SWRlbnRpdHlOb2RlOjNjZjI1NDBjLWRmNjItNDBmNC1hNzQ2LTdiNjM5ZTZkOGY4Mw=="
export const IDENTITY_PICSA_ADVISORY_SERVICES = "SWRlbnRpdHlOb2RlOmQ0ZWUyM2UwLTdlYzUtNDdiYy04ODM5LWNlMzdlZWZlZjMzMQ=="
export const IDENTITY_DANELL = "SWRlbnRpdHlOb2RlOmZmNzg5ZDlhLTBlNjktNDQ2MS05YmE5LWFiODY5ZjFkYjcyZQ=="
export const IDENTITY_CAROL = "SWRlbnRpdHlOb2RlOmNlNTgxZmM0LTY4ZjctNGRkYy05M2NjLTIwOWQ0YjUxMGYxMg=="
export const IDENTITY_DION = "SWRlbnRpdHlOb2RlOjNlN2RjMTdjLTc0YjItNGYyYS05NmFjLTNlYTgxNGQwZWUwMA=="
export const IDENTITY_THIAN = "SWRlbnRpdHlOb2RlOmY3ZTg0NGY3LWFiZWItNDA1NC04NjIwLWMwZTdjZGFmZjVjNw=="
export const EMPLOYER_PICSA_ADVISORY_SERVICES = "RW1wbG95ZXJOb2RlOmUwMjNkODU2LWEyNzQtNGVlMi04NGViLWMxNjgyZmE2ZTI1MQ=="
export const EMPLOYER_TWO_A_DAY = "RW1wbG95ZXJOb2RlOjc4MTkwMzZlLTAyMjItNDE1OC04MzFlLTZhMzQyZmFkZmI2NA=="
export const EMPLOYER_TWO_A_DAY_STG = "RW1wbG95ZXJOb2RlOjk5YjRkMGZlLTYwNmMtNDk3Ni1iZjJlLWQ4OGQxMGI5NWRiNQ=="
export const EMPLOYER_MESSAGEPLUS = "RW1wbG95ZXJOb2RlOjI3ZmM2NDM3LWFlZjgtNGU4Ni04NzdjLTY5MWZiOTFjZmZlYQ=="
export const EMPLOYER_STRATHBREEDE = "RW1wbG95ZXJOb2RlOmExODg3NjQyLTBkNjMtNDNhOC04MDQ1LTBjYjYwN2QyNWFkZQ=="

// message channel ids
export const CHANNEL_SMS = "Q2hhbm5lbE5vZGU6YTgzNWRhM2YtNTc5NS00ZjEzLThlMGUtM2RlZjUxM2I1MjRi"
export const CHANNEL_SMS_MESSAGEPLUS = "Q2hhbm5lbE5vZGU6MDI3OTE3YmUtZTNmMi00ZGIzLWJhOWUtZjU4OThmYjBkZWE5"
export const CHANNEL_TELEGRAM_BROADCAST = "Q2hhbm5lbE5vZGU6OTkxZTg1NDEtMjQzMS00MTczLThlMmQtMTZlYmI5YzQ4Yjg2"

export const WORKFLOW_RECEIPT_INVESTMENTS = "V29ya2Zsb3dOb2RlOjQ1Y2MxYmMwLWFkMzktNGIxOS05NjY1LWNmZjYyOTQzY2U3ZA=="
export const WORKFLOW_LOAN_DISBURSAL = "V29ya2Zsb3dOb2RlOjJmMTUwNmVlLTQyZjYtNDEzNC05OTY3LWY0N2RhMTFkNWM5ZQ=="

// product colour constants
export const COLOUR_CASH_LOAN_1 = '#edf4f2'
export const COLOUR_CASH_LOAN_2 = '#7dbc42'  // can be used if 'accent' as is brighest of 3
export const COLOUR_CASH_LOAN_3 = '#23894d'

export const COLOUR_RETAIL_LOAN_1 = '#f1f6fa'
export const COLOUR_RETAIL_LOAN_2 = '#49c2cc'  // can be used if 'accent' as is brighest of 3
export const COLOUR_RETAIL_LOAN_3 = '#007c95'

export const COLOUR_CONSOLIDATION_LOAN_1 = '#fdf5e6'
export const COLOUR_CONSOLIDATION_LOAN_2 = '#ffc433'  // can be used if 'accent' as is brighest of 3
export const COLOUR_CONSOLIDATION_LOAN_3 = '#e89d1a'

export const COLOUR_SHORT_TERM_INVESTMENT_1 = '#e7edf0'
export const COLOUR_SHORT_TERM_INVESTMENT_2 = '#a8bbc6'  // can be used if 'accent' as is brighest of 3
export const COLOUR_SHORT_TERM_INVESTMENT_3 = '#5d7f8f'
export const COLOUR_SHORT_TERM_INVESTMENT_4 = '#3C6173'  // used as product card footer background

export const COLOUR_LONG_TERM_INVESTMENT_1 = '#e9eaed'
export const COLOUR_LONG_TERM_INVESTMENT_2 = '#647481'  // can be used if 'accent' as is brighest of 3
export const COLOUR_LONG_TERM_INVESTMENT_3 = '#242a3c'
export const COLOUR_LONG_TERM_INVESTMENT_4 = '#101420'  // used as product card footer background

export const COLOUR_FUNERAL_COVER_1 = '#f8f6f2'
export const COLOUR_FUNERAL_COVER_2 = '#e8e0d5'  // can be used if 'accent' as is brighest of 3
export const COLOUR_FUNERAL_COVER_3 = '#5a544a'

// forms
export const FORM_INVESTMENT_WITHDRAWAL_APPLICATION = "Rm9ybU5vZGU6MGRiY2Q2OWItZDlhMC00MGFlLThmZDItOTI5NDg3ODc2YTQx"

// request types
export const REQUESTTYPE_INVESTMENT_WITHDRAWAL_APPLICATION = "UmVxdWVzdFR5cGVOb2RlOmRkZjA4YzUxLWM4OTQtNDQzNC1hNzEwLTYxNWFhMjkzOThmYQ=="
export const REQUESTTYPE_INVESTMENT_APPLICATION = "UmVxdWVzdFR5cGVOb2RlOjExZDQ4NmNjLWUxZDktNDViZi1iZjcwLTJiMmViNzk1YTY5Yw=="
export const REQUESTTYPE_LOANAPPLICATION = "UmVxdWVzdFR5cGVOb2RlOjA0OGVhODEyLWNlZTgtNDRhZi1iYTk2LThjNWYzNDEwNDg5ZQ=="
export const REQUESTTYPE_CREDITAPPLICATION = "UmVxdWVzdFR5cGVOb2RlOjgwODZmZjc5LTkzN2QtNDFmMC04ZDRlLTc2ZTc3YjgwNzAxNg=="
export const REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE = "UmVxdWVzdFR5cGVOb2RlOjdjYjZiZGJiLTEwOWEtNDAyZC05NTZkLTllN2JkZTJlZDlhOQ=="
export const REQUESTTYPE_CELLPHONE_NUMBER_CHANGE = "UmVxdWVzdFR5cGVOb2RlOjJkMWU3MDcxLTljODctNGM1Yy04ZjYzLTBmY2MxZjc0MGFjZA=="
export const REQUESTTYPE_IDENTITY_VERIFICATION = "UmVxdWVzdFR5cGVOb2RlOjFjMzlhNjNmLTZhMjQtNGE1YS1iMDU0LWNkN2QzOTQ2ZTA1ZQ=="

// impact report
export const IMPACT_REPORT_DATE = '2020-08-07'

// metrics
export const METRIC_PICSA_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZTpkYjc2ZjkwYy1kN2ZiLTQ2ZmYtOWMwNC1iMTE3ODMzYjk4YzQ='
export const METRIC_CLIENT_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZToyOTIzZDM5ZC0yNjRjLTQ4YzQtYTdjZi04Mzc0MGVmMjAwMDA='
export const METRIC_INVESTMENT_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZTozMTliYmM3NS01ZTRhLTQzZDUtOWU0ZS05MGMwMDNiNGRmZjA='
export const METRIC_CREDIT_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZToyZGEzMjJjNC1mZGRjLTQ0MTktOTFlOS1hNmU2MjExZTcxNDM='
export const METRIC_EMPLOYER_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZToxZGNmNzI5MS1hZTVjLTQ3MGYtOWE5Yi0zY2FkMDkwZDJlODY='

// nodes to urls
export const NODES = {
  'IdentityNode': {
    base: '/os',
    endpoint: '/identity',
    query: `
      query($id: ID!) {
        object: identity(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'identity'
  },
  'RequestRunNode': {
    base: '/os/operations/general',
    endpoint: '/requests',
    query: `
      query($id: ID!) {
        object: requestrun(id: $id) {
          id
          summary
          context: identity {
            id
          }
        }
      }
    `,
    contentTypeModel: 'requestrun'
  },
  'CaseNode': {
    base: '/os',
    endpoint: '/cases',
    query: `
      query($id: ID!) {
        object: case(id: $id) {
          id
          context: affects {
            id
          }
        }
      }
    `,
    contentTypeModel: 'case'
  },
  'FileNode': {
    base: '/os/operations/general',
    endpoint: '/files',
    query: `
      query($id: ID!) {
        object: file(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'file'
  },
  'WhatsappMessageNode': {
    base: '/os/communications',
    endpoint: '/whatsapp',
    query: `
      query($id: ID!) {
        object: whatsappmessage(id: $id) {
          id
          summary
          context: fromIdentity {
            id
          }
        }
      }
    `,
    contentTypeModel: 'whatsappmessage'
  },
  'PayrollRunNode': {
    base: '/os/operations/general',
    endpoint: '/payrollruns',
    query: `
      query($id: ID!) {
        object: payrollrun(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'payrollrun'
  },
  'EmailNode': {
    base: '/os/communications',
    endpoint: '',
    query: `
      query($id: ID!) {
        object: email(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'email'
  },
  'MessageNode': {
    base: '/os/communications',
    endpoint: '',
    query: `
      query($id: ID!) {
        object: message(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'message'
  },
  'CreditNode': {
    base: '/os/products',
    endpoint: '/credit',
    query: `
      query($id: ID!) {
        object: credit(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'credit'
  },
  'CreditApplicationNode': {
    base: '/os/products/credit',
    endpoint: '/applications',
    query: `
      query($id: ID!) {
        object: creditapplication(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'creditapplication'
  },
  'LoanNode': {
    base: '/os/products',
    endpoint: '/credit',
    query: `
      query($id: ID!) {
        object: loan(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'loan'
  },
  'LoanApplicationNode': {
    base: '/os/products/credit',
    endpoint: '/applications',
    query: `
      query($id: ID!) {
        object: loanapplication(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'loanapplication'
  },
  'ClientInstrumentNode': {
    base: '/os/products',
    endpoint: '/investments',
    query: `
      query($id: ID!) {
        object: clientinstrument(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'clientinstrument'
  },
  'ClientFuneralPolicyNode': {
    base: '/os/products',
    endpoint: '/insurance',
    query: `
      query($id: ID!) {
        object: clientfuneralpolicy(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'clientfuneralpolicy'
  }
  // TODO: add more as/when needed
}

// listing pages
export const DEFAULT_RESULTS_PER_PAGE = 15

export const ACCOUNT_TYPE_EARNBACKS = 'QWNjb3VudFR5cGVOb2RlOjE4Njk0Zjc4LTdlNGEtNGM2Yy04NTQyLWQxNDUxNTg0N2ZlMQ=='
export const ACCOUNT_TYPE_EARNBACKS_MEMBERSHIP = 'QWNjb3VudFR5cGVOb2RlOjZhYzNlZWQ4LTY3MmEtNDZkMS1iNDgyLTUxMGNiM2Y1MzkwMQ=='

export const PAYROLL_RUN_FIRST_PAID_ON = '2017-11-02'
export const COREID_ACTIVE = false
export const NUMBER_CHANGE_ACTIVE = true



// WEBPACK FOOTER //
// ./src/constants.js